export const PROJECT_COVER_WIDTH = 248;
export const MOBILE_PROJECT_COVER_WIDTH = 320;
export const PROJECT_COVER_ASPECT_RATIO = 1.333;
